import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { onRouteChange } from './index'

// Reports SPA route changes to the analytics orchestrator, with the previous
// in-app URL as referrer. The first render is skipped: the vendors record the
// landing page themselves when they load (with the URL already redacted).
export function usePageAnalytics(): void {
  const { pathname, search } = useLocation()
  const previous = useRef<string | null>(null)
  useEffect(() => {
    const url = window.location.href
    if (previous.current !== null && previous.current !== url) {
      onRouteChange(url, previous.current, pathname)
    }
    previous.current = url
  }, [pathname, search])
}
